import moment from 'moment';
import { ILinechartData, IsoString } from 'models';
import { ACCENT_COLOR, TERTIARY_COLOR } from 'utils';

export const createGraphicData = (
	graphicData: Record<IsoString, number>,
): ILinechartData => {
	const months = getMonths(graphicData);

	return {
		labels: months,
		datasets: [
			{
				data: getData(graphicData),
				borderColor: TERTIARY_COLOR,
				borderWidth: 2,
				fill: false,
			},
		],
	};
};

function getMonths(graphicData: Record<IsoString, number>) {
	return Object.keys(graphicData).map((date) => moment(date).format('MMM'));
}

function getData(graphicData: Record<IsoString, number>) {
	return Object.values(graphicData);
}
